import React from 'react';

import { ListState } from '~src/main/ui/list-state';
import { AriaGrid, useAriaGridCell } from '~src/main/ui/aria-grid';
import { useScrollIntoView } from '~src/main/ui/scroll-into-view';

import { CountryCard } from './country-card';

interface CountrySelectItemProps {
  country: [string, string];
  listState: ListState<[string, string]>;
}

const CountrySelectItem: React.FC<CountrySelectItemProps> = ({ country, listState }) => {
  const ref = React.useRef(null);

  const { cellProps, isSelected } = useAriaGridCell({
    itemKey: country[0],
    listState,
    ref,
    enableAutoSelect: true,
  });

  useScrollIntoView(ref, isSelected);

  return (
    <CountryCard
      country={country[0]}
      countryName={country[1]}
      innerRef={ref}
      selected={isSelected}
      {...cellProps}
    />
  );
};

interface CountrySelectListProps {
  listState: ListState<[string, string]>;
}

export const CountrySelectList: React.FC<CountrySelectListProps> = ({ listState }) => {
  return (
    <AriaGrid listState={listState}>
      {(country: [string, string]) => (
        <CountrySelectItem key={country[0]} country={country} listState={listState} />
      )}
    </AriaGrid>
  );
};
